import { useTranslation } from 'react-i18next';
import { useAlert } from 'src/hooks/useAlert';
import { ALERT } from 'src/types/enum';
import { TRANSLATION_CONSTANTS as T } from 'src/utils/translations';

export function useMicrophonePermission() {
  const { showAlert } = useAlert();
  const { t } = useTranslation();

  const hasMicrophonePermission = async (): Promise<boolean> => {
    try {
      const permission = await navigator.permissions.query({
        name: 'microphone' as PermissionName
      });

      return permission.state === 'granted';
    } catch {
      return false;
    }
  };

  const requestMicrophonePermission = async (): Promise<boolean> => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      stream.getTracks().forEach((track) => track.stop());
      return true;
    } catch {
      return false;
    }
  };

  const ensureMicrophoneAccess = async (): Promise<boolean> => {
    const granted = await hasMicrophonePermission();
    if (granted) {
      return true;
    }

    const result = await requestMicrophonePermission();
    if (!result) {
      showAlert(ALERT.ERROR, t(T.microphoneAccessError));
    }
    return result;
  };

  return {
    hasMicrophonePermission,
    requestMicrophonePermission,
    ensureMicrophoneAccess
  };
}
